import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function IpDispensation({
  singleSubjectId,
}: {
  singleSubjectId?: string;
}) {
  const { id } = useScopeParams();

  return (
    <PageTemplate
      title="Safety: IP Dispensation"
      tooltipText="Explore IP dispensation records, create data subsets, and download data."
      type="ip_dispensation"
      constants={{
        wikiLink: "/wiki/guides/exploration-safety-ip-dispensation",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/ip-dispensation`,
      }}
      subjectId={singleSubjectId}
    />
  );
}
